<div class="flex flex-col gap-4">

  <app-in-home-care [assigned]="true"></app-in-home-care>

  <in-home-care-change [assigned]="true"></in-home-care-change>

</div>
